import { Component, ElementRef, Inject, InjectionToken, OnInit, ViewChild } from '@angular/core';
import { IInjectedElementDtype } from '../../../models/InjectedElementDtype';
import { IndicatorVisual, IPlanogramIndicator, resolveIndicatorVisual } from '../../../models/indicators';
import { ITableColumnTags } from '../../../models/table';

import { SessionService } from '../../../services/session.service';

import { SHARED_MODULES } from '../../../../shared.';
import { GetLinkPipe } from '../../../pipes/get-link.pipe';
import { FilterByPipe } from '../../../pipes/filter-by.pipe';
import { LinkTypePipe } from '../../../pipes/link-type.pipe';
import { SanitizerPipe } from '../../../pipes/sanitizer.pipe';
import { ColorTagsDirective } from '../../../directives/color-tags.directive';
import { PhTooltipDirective } from '../../../directives/ph-tooltip.directive';
import { PhIconComponent } from '../../ph-icon/ph-icon.component';

export const ELEMENT = new InjectionToken<any>('element', {
	providedIn: 'root',
	factory: () => 'element'
});

export type LinkDtypeElement<T> = {
	dtype: 'link';
	image_tooltip?: string;
	indicators: Array<IPlanogramIndicator>;
	links: Array<T>;
	mtype: string;
	tags?: ITableColumnTags;
	target: '_blank' | '_self';
	value: string;
}

@Component({
    selector: 'app-link-dtype',
    templateUrl: 'link-dtype.component.html',
    styleUrls: ['link-dtype.component.scss'],
	imports: [
		SHARED_MODULES,
		FilterByPipe,
		GetLinkPipe,
		LinkTypePipe,
		SanitizerPipe,
		ColorTagsDirective,
		PhTooltipDirective,
		PhIconComponent
	],
    standalone: true
})
export class LinkDtypeComponent implements OnInit {

	public element: LinkDtypeElement<any>;
	public indicators: Array<IndicatorVisual> = [];
	public isLinksMenu: boolean = false;
	public isTooltip: boolean = false;

	@ViewChild('inputElement') inputElement: ElementRef;

	constructor(
		@Inject(ELEMENT) private elementInjected:  IInjectedElementDtype<LinkDtypeElement<any>>,
		private sessionService: SessionService
	) {}

	ngOnInit(): void {
		this.element = this.elementInjected.element;

		if (this.sessionService.hasAccess('ph-planogram-edit')) {
			this.element.indicators.forEach((indicator: IPlanogramIndicator) => {
				if (indicator.type == 'WARNING' && !this.sessionService.personalSettings.warningIndicators) return;
				if (indicator.type == 'ERROR' && !this.sessionService.personalSettings.errorIndicators) return;

				this.indicators.push(resolveIndicatorVisual(indicator));
			});
		}
		else if (this.sessionService.defaults.isManager) {
			this.element.indicators
				.filter((indicator: IPlanogramIndicator): boolean => indicator.type === 'SCHEDULED')
				.forEach((indicator: IPlanogramIndicator): void => {
					this.indicators.push(resolveIndicatorVisual(indicator));
				});
		}

		this.isLinksMenu = this.element.links.length > 1;
		this.isTooltip = this.elementInjected.isTooltip;
	}

	openLinksMenu(): void {
		this.inputElement.nativeElement.focus();
	}
}
